// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Document layout: center in the same 800px reading column as the messages,
   with the avatar/header aligned to where the message turns' headers sit. */
.supervisor-thinking {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 22px 28px;
    box-sizing: border-box;
    animation: thinking-fade-in 0.3s ease-in;
}

.supervisor-thinking-avatar {
    flex-shrink: 0;
}

/* Match the 26px message-head avatar size. */
.supervisor-thinking-avatar .MuiAvatar-root {
    width: 26px !important;
    height: 26px !important;
}

.supervisor-thinking-body {
    flex: 1 1;
    min-width: 0;
    padding-top: 4px;
}

.supervisor-thinking-header {
    font-size: 14px;
    font-weight: 600;
    font-style: italic;
    opacity: 0.85;
    letter-spacing: 0.02em;
}

.supervisor-thinking-steps {
    list-style: none;
    margin: 6px 0 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.supervisor-thinking-step {
    font-size: 12px;
    opacity: 0.7;
    display: flex;
    align-items: center;
    gap: 6px;
    animation: step-fade-in 0.25s ease-in;
}

.supervisor-thinking-step-icon {
    font-size: 11px;
    opacity: 0.6;
    flex-shrink: 0;
}

/* RTL: keep the centered column, mirror avatar/header to the right. */
.messages.rtl .supervisor-thinking {
    flex-direction: row-reverse;
}

@keyframes thinking-fade-in {
    from { opacity: 0; }
    to   { opacity: 1; }
}

@keyframes step-fade-in {
    from { opacity: 0; transform: translateY(2px); }
    to   { opacity: 0.7; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/components/ThinkingMessage/ThinkingMessage.css"],"names":[],"mappings":"AAAA;4EAC4E;AAC5E;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA,6CAA6C;AAC7C;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA,sEAAsE;AACtE;IACI,2BAA2B;AAC/B;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,YAAY,EAAE,wBAAwB,EAAE;AACnD","sourcesContent":["/* Document layout: center in the same 800px reading column as the messages,\n   with the avatar/header aligned to where the message turns' headers sit. */\n.supervisor-thinking {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 22px 28px;\n    box-sizing: border-box;\n    animation: thinking-fade-in 0.3s ease-in;\n}\n\n.supervisor-thinking-avatar {\n    flex-shrink: 0;\n}\n\n/* Match the 26px message-head avatar size. */\n.supervisor-thinking-avatar .MuiAvatar-root {\n    width: 26px !important;\n    height: 26px !important;\n}\n\n.supervisor-thinking-body {\n    flex: 1;\n    min-width: 0;\n    padding-top: 4px;\n}\n\n.supervisor-thinking-header {\n    font-size: 14px;\n    font-weight: 600;\n    font-style: italic;\n    opacity: 0.85;\n    letter-spacing: 0.02em;\n}\n\n.supervisor-thinking-steps {\n    list-style: none;\n    margin: 6px 0 0 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.supervisor-thinking-step {\n    font-size: 12px;\n    opacity: 0.7;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    animation: step-fade-in 0.25s ease-in;\n}\n\n.supervisor-thinking-step-icon {\n    font-size: 11px;\n    opacity: 0.6;\n    flex-shrink: 0;\n}\n\n/* RTL: keep the centered column, mirror avatar/header to the right. */\n.messages.rtl .supervisor-thinking {\n    flex-direction: row-reverse;\n}\n\n@keyframes thinking-fade-in {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n}\n\n@keyframes step-fade-in {\n    from { opacity: 0; transform: translateY(2px); }\n    to   { opacity: 0.7; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
